import e from "../../utils/classNames.js";
import { omit as t } from "es-toolkit/compat";
import { jsx as n } from "react/jsx-runtime";
//#region src/components/actionBarItem/ActionBarItemPopoverContent.tsx
var r = ({ className: r, children: i, ...a }) => {
	let o = e("ActionBarItemPopoverContent", r), s = t(a, ["title", "useOffscreen"]);
	return /* @__PURE__ */ n("div", {
		...s,
		className: o,
		children: i
	});
};
r.displayName = "ActionBarItemPopoverContent";
//#endregion
export { r as default };

//# sourceMappingURL=ActionBarItemPopoverContent.js.map